<template>
    <div>
        <div class="white-box">
            <h4 class="mb-3.5">
                請提供資金來源及財務狀況
            </h4>
            <h5 class="mb-2.5 pb-2.5 border-b border-dashed border-gray-100">
                資金來源
                <span class="text-error"> (必填，可複選)</span>
            </h5>
            <div class="flex flex-wrap mt-4 mb-5">
                <Checkbox
                    v-for="(item, i) in sourse"
                    :key="i"
                    v-model:checkedValues="fundsSourceList"
                    :value="item.value"
                    :text="item.name"
                    class="mb-2"
                />
                <Checkbox
                    v-model:checkedValues="fundsSourceList"
                    value="5"
                    class="mb-2"
                    @input="removeErrorMsg"
                >
                    <div class="flex text-gray-700">
                        <div class="text-base xs:text-lg flex-shrink-0 mr-1.5 label-base">
                            其他
                        </div>
                        <div class="w-[12.5rem] md:w-[11.25rem] relative">
                            <input
                                v-model="fundsMemo"
                                :disabled="!fundsSourceList.find( i => i ==='5')"
                                type="text"
                                class="input-base"
                                autocomplete="off"
                                maxlength="100"
                                @input="validateMemo(fundsMemo)"
                            >
                            <p class="text-error text-base text-right absolute right-0">
                                {{ fundsMemoErrMsg }}
                            </p>
                        </div>
                    </div>
                </Checkbox>
            </div>
            <h5 class="mb-2.5">
                財務狀況
                <span class="text-error"> (必填)</span>
            </h5>
            <h5 class="pb-2.5 text-error font-normal border-b border-dashed border-gray-100 md:border-0">
                若無，請填寫0元
            </h5>
            <div class="divide-y divide-dashed divide-gray-100 md:grid md:grid-cols-2 xl:grid-cols-3">
                <label
                    v-for="item in financialCondition"
                    :key="item.id"
                    class="flex w-full justify-start py-2.5 md:border-t md:border-dashed md:border-gray-100 last:hidden last:md:block"
                >
                    <div
                        class="text-base flex-shrink-0 label-base text-gray-700 w-[9.625rem]"
                        v-html="item.name"
                    />
                    <div
                        v-if="item.id"
                        class="w-full max-w-[13.75rem] md:max-w-[11.25rem]"
                    >
                        <div
                            class="input-wanyuan"
                            data-domain="萬元"
                        >
                            <input
                                v-model.trim="item.amount"
                                type="text"
                                class="input-base pr-12 text-right"
                                inputmode="numeric"
                                autocomplete="off"
                                maxlength="11"
                                @input="validateAmount(item)"
                            >
                        </div>
                        <p class="text-error text-right">{{ item.errorMassage }}</p>
                    </div>
                </label>
            </div>
            <h4 class="mt-5 mb-3 md:mb-3.5">
                重要告知與提醒事項
            </h4>
            <!-- 同意書 -->
            <TermsFrame
                need-layer
                need-checkbox
                checkbox-text="已充分閱讀且了解相關權益及可能風險"
                height="h-[18.75rem] md:h-[15.875rem]"
                :content="contents"
                @isScrollToBottom="v => isCheckboxDisable = !v"
                @isAgree="value=> isAgree = value"
            />
        </div>
        <Bottombar>
            <template #left>
                <button
                    class="btn-text arrow-l"
                    @click="goBack"
                >
                    修改投資金額與配置比例
                </button>
            </template>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="!isAgree"
                    @click="validGoNext"
                />
            </template>
        </Bottombar>
        <Loading :is-loading="isLoading" />
    </div>
</template>

<script>
import { computed, ref, inject, reactive, toRefs } from 'vue';
import { integer } from '@/utils/rules/customRules.js';
import { content } from './content';
import { submitSourceA5 } from '@/apis/A5';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Checkbox from '@/components/checkboxs/Checkbox.vue';
import TermsFrame from '@/components/template/TermsFrame.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import dialogContnet from '@/json/dialogContent.js';
import Loading from '@/components/Loading.vue';
import routeName from '@/router/constant.js';

export default {
    components: {
        Checkbox,
        TermsFrame,
        Bottombar,
        ButtonNextService,
        Loading
    },
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const { code } = route.meta;
        const state = reactive({
            isLoading: false,
            isCheckboxDisable: true,
            isAgree: false,
            isSubmitOk: false,
        });
        const contents = ref('');
        const data = reactive({
            fundsSourceList: [],
            fundsMemo: '',
            fundsMemoErrMsg: '',
            financialCondition: [
                { name: '要保人家庭年收入', amount: '', id: 'incomeCustA', errorMassage: '' },
                { name: '被保險人家庭年收入', amount: '', id: 'incomeCustI', errorMassage: '' },
                { name: '動產<br>(含存款/股票/基金)', amount: '', id: 'chattel', errorMassage: '' },
                { name: '不動產', amount: '', id: 'estate', errorMassage: '' },
                { name: '負債', amount: '', id: 'liabilities', errorMassage: '' },
                { name: '', amount: '', id: '', errorMassage: '' },
            ],
            sourse: [
                { name: '薪資', value: '1' },
                { name: '投資收入', value: '2' },
                { name: '存款', value: '4' },
                { name: '退休金', value: '3' },
                { name: '財產繼承', value: '6' },
                { name: '貸款', value: '7' },
                { name: '保單借款', value: '9' },
                { name: '終止契約(解約)', value: 'B' }
            ],
        });
        const result = computed(() => store.state.services.changeItemsResult[code]);

        if (result.value) {
            const { storeFundsSourceList, storeFundsMemo, storeFinancialCondition } = result.value;
            data.fundsSourceList = storeFundsSourceList;
            data.fundsMemo = storeFundsMemo;
            data.financialCondition = storeFinancialCondition;
        }

        const validateMemo = (value) => {
            data.fundsMemoErrMsg = value.length > 100 ? '請小於100位字元' : '';
            data.fundsMemoErrMsg = data.fundsSourceList.includes('5') && !value ? '請輸入其他資金來源' : '';
        };

        const validateAmount = (item) => {
            item.amount = isNaN(Number(item.amount)) ? item.amount : Number(item.amount);
            const errorMessage = integer(item.amount);
            errorMessage ? item.errorMassage = errorMessage : item.errorMassage = '';
        };

        const removeErrorMsg = () => {
            if (!data.fundsSourceList.includes('5')) {
                data.fundsMemo = '';
                data.fundsMemoErrMsg = '';
            }
        };

        const validGoNext = () => {
            let hasError = false;
            data.fundsMemoErrMsg = data.fundsSourceList.includes('5') && !data.fundsMemo ? '請輸入其他資金來源' : '';
            data.financialCondition.forEach(i => {
                if (i.name && i.amount === '') i.errorMassage = '若無，請填寫0元';
            });
            hasError = data.financialCondition.some(i => i.errorMassage !== '') || data.fundsMemoErrMsg !== '';

            if (data.fundsSourceList.length === 0) {
                /* 資金來源未勾選 */
                const params = {
                    title: '提示',
                    content: '資金來源未勾選，請確認。',
                    confirmButton: '確認',
                    cancelButton: null,
                    closeicon: true,
                };
                modalShow(params);
            } else if (data.financialCondition.every(i => i.amount === '')) {
                /* 財務狀況未填寫 */
                const params = {
                    title: '提示',
                    content: '財務狀況未填寫完整，請補填。',
                    confirmButton: '確認',
                    cancelButton: null,
                    closeicon: true,
                };
                modalShow(params);
            } else if (hasError) {
                modalShow(dialogContnet.validateMsg);
            } else {
                submit();
            }
        };

        const submit = () => {
            state.isLoading = true;
            const returnData = {};
            returnData.fundsSourceList = data.fundsSourceList;
            returnData.fundsMemo = data.fundsSourceList.includes('5') ? data.fundsMemo : null;
            data.financialCondition.forEach(i => {
                if (i.id === 'incomeCustA') returnData.incomeCustA = i.amount;
                if (i.id === 'incomeCustI') returnData.incomeCustI = i.amount;
                if (i.id === 'chattel') returnData.chattel = i.amount;
                if (i.id === 'estate') returnData.estate = i.amount;
                if (i.id === 'liabilities') returnData.liabilities = i.amount;
            });
            submitSourceA5(returnData).then(res => {
                const list = {
                    storeFundsSourceList: data.fundsSourceList,
                    storeFundsMemo: data.fundsMemo,
                    storeFinancialCondition: data.financialCondition
                };
                store.dispatch('services/setChangeItemsResult', { code, value: list });
                state.isSubmitOk = true;
            }).finally(() => {
                state.isLoading = false;
            });
        };

        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };

        /** 上一步 */
        const goBack = () => {
            router.push({ name: routeName.ONE_TIME_INVEST });
        };

        setTimeout(() => {
            contents.value = content;
        }, 1000);

        return {
            ...toRefs(state),
            ...toRefs(data),
            contents,
            goBack,
            removeErrorMsg,
            validateMemo,
            validateAmount,
            validGoNext
        };
    }
};
</script>
<style lang="scss" scoped>
.input-wanyuan {
    @apply relative;
    &::after {
        content: "" attr(data-domain);
        @apply inline-block text-gray-700 text-base xs:text-lg absolute right-2.5 top-1/2 -translate-y-1/2;
    }
}
</style>
